import React, { useState, useEffect } from "react";
import { requestGetAll } from "../API/request_server";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import OurServices from "../components/Services";
import Heading from "../components/Heading";

const AboutUs = () => {
  const theme = useTheme();
  const [_OpenModal, _setOpenModal] = useState(false);
  const [_loader, _setLoader] = useState(true);
  const [image, setImage] = useState("https://via.placeholder.com/300");
  const [_inputData, _setInputData] = useState({
    id: null,
    description: "",
    image: null,
  });
  const getData = async () => {
    _setLoader(true);
    const result = await requestGetAll("about/getall");
    if (result) {
      const item = result?.data?.[0];
      _setInputData({
        id: item.about_id,
        description: item.description || "",
        image: item.image || null,
      });
      setImage(
        item.image
          ? `https://ptp.gkp.pk/backend_ptp_admin/${item.image}`
          : // ? `http://localhost/backend_ptp_admin/${item.image}`
            "https://via.placeholder.com/300",
      );
    }
    _setLoader(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Box
      sx={{
        py: { xs: 6, md: 2 },
        background: "#f8fafc",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 6, md: 4 }}>
            <Box
              component="img"
              src={image}
              alt="About Us"
              sx={{
                width: "100%",
                height: { xs: 300, md: 500 },
                objectFit: "cover",
                borderRadius: "24px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
              }}
            />
          </Grid>
          <Grid size={{ xs: 6, md: 8 }}>
            <Stack spacing={3}>
              <Heading _title="About PTP Kp" align="left" />

              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  fontSize: "1rem",
                }}
              >
                {_inputData.description}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
        <OurServices />
      </Container>
    </Box>
  );
};

export default AboutUs;
